import React from 'react';
import { styled, keyframes } from '@mui/material/styles';

function TopArea({ easyText, dentalText, helpRaindropText, freeText, imgSrc }) {
  return (
    <BackgroundDiv>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1, marginBottom: '5%' }}>
        <h1 style={{ fontWeight: 300, fontSize: '4rem', whiteSpace: 'nowrap' }}>
          {easyText}{' '}
          <span
            style={{
              fontWeight: 'bold',
              background:
                'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)), linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            {dentalText}
          </span>
          <br />
          {helpRaindropText}
        </h1>
        <a
          href="/license"
          style={{
            padding: '1rem 2rem',
            textDecoration: 'none',
            background:
              'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)),linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
            borderRadius: '30px',
            color: '#fff',
            fontSize: '1.2rem',
            lineHeight: 1,
            marginTop: '20px',
          }}
        >
          {freeText}
        </a>
      </div>
      <MainImg src={imgSrc} alt="Program_img" />
    </BackgroundDiv>
  );
}

const BackgroundDiv = styled('div')(() => ({
  background: 'url(/images/main/main_background.png) #ffffff no-repeat',
  backgroundAttachment: 'fixed',
  backgroundPosition: 'center',
  animation: `${expandBackground} 3s ease-in-out infinite alternate`,
  padding: '0',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  minHeight: 'calc(100vh - 100px)',
  '& .swiper-pagination': {
    bottom: '0 !important',
  },

  '& .swiper-slide': {
    justifyContent: 'flex-end',
  },
}));

const MainImg = styled('img')(() => ({
  position: 'absolute',
  left: '25%',
  animation: `${MotionImage} 3s ease-in-out infinite alternate`,
}));

const expandBackground = keyframes`
  0% {
    background-size: 100%;
  }
  50% {
    background-size: 105%;
  }
  100% {
    background-size: 100%;
  }
`;

const MotionImage = keyframes`
  0% {
    bottom: -5%
  }
  50% {
    bottom: -10%
  }
  100% {
    bottom: -5%
  }
`;

export default TopArea;
